module.exports = __webpack_public_path__ + "static/media/Bluelab Commercial Truncheon Nutrient Meter.018a4ab4.webp";